import React, { useEffect } from 'react';

import { SmsInstantRedirectConfigItem } from '@shared/config/sms-instant-redirect-config';
import { prepareSMSURI, setTheme } from '@shared/utils/general';
import { APP_THEMES } from '@shared/config/constants/app';
import { isDesktop } from 'react-device-detect';

type Props = SmsInstantRedirectConfigItem;

const DCBSms: React.FC<Props> = ({ shortCode, body }) => {
  useEffect(() => {
    setTheme(APP_THEMES.WHITE);
  }, []);

  useEffect(() => {
    if (isDesktop) return;

    const smsUri = prepareSMSURI(shortCode, body);
    // @ts-ignore
    window.location = smsUri as Location | (string & Location);
  }, [shortCode, body]);

  return isDesktop ? <p>Service only supports Android and IOS Devices</p> : null;
};

export { DCBSms };
